const bean = {
  bean: 'فاصوليا',
  tips: '* الحد الأدنى لعدد الفاصوليا تبادل: {{ num }}',
  dailyExchangeTimes: 'أوقات التبادل اليومية:',
  dailyExchangeQuota: 'حد التبادل اليومي:',
  monthlyExchangeQuota: 'حد التبادل الشهري:',
  confirmTitle: 'للعملة ذهبية',
  confirmTips: 'يرجى التحقق من المبلغ الذي تريد استبداله (رصيد الفاصوليا {{amount}})',
};

const coffee = {
  coffee: 'قهوة',
  tips: '* الحد الأدنى لكمية القهوة للتبادل: {{ num }}',
  dailyExchangeTimes: 'أوقات التبادل اليومية:',
  dailyExchangeQuota: 'حد التبادل اليومي:',
  monthlyExchangeQuota: 'حد التبادل الشهري:',
  confirmTitle: 'للعملة ذهبية',
  confirmTips: 'يرجى التحقق من المبلغ الذي تريد استبداله (رصيد القهوة {{amount}})',
};

const pearl = {
  pearl: 'لؤلؤة',
  confirmTitle: 'للعملة ذهبية',
  confirmTips: 'يرجى التحقق من المبلغ الذي تريد استبداله (رصيد الفاصوليا {{amount}})',
  amountTips: 'الحد الأدنى لعدد اللؤلؤة الإرسال:{{ num }}',
};

export default {
  title: 'التبادل',
  enter: 'أدخل حساب المستلم',
  exchanging: 'التبادل',
  rateBeanToCoin: '{{bean}} فاصوليا = {{coin}} عملات ذهبية',
  rateCoffeeToCoin: '{{coffee}} مل = {{coin}} عملات ذهبية',
  success: 'تم التبادل بنجاح',
  successTips: 'يرجى التحقق من المبلغ الذي قمت بتبادله ',
  failure: 'تحذير',
  failureTips: 'المعاملات الحالية غير طبيعية، يرجى الانتقال إلى تفاصيل المعاملات للتحقق من النتائج',
  minNum: 'يتطلب {{num}} حبة في كل مرة',
  bean,
  pearl,
  coffee,
};
